import type { Feature } from './flags';

// Read/write a localStorage override for a flag. Used to pin a flag value during local dev
// without touching the Split or Statsig dashboards. The override is keyed by Feature name
// inside a single `feature_flags` JSON blob.

export function getLocalFlag(feature: Feature): string | undefined {
  if (typeof window === 'undefined') return undefined;
  if (!window.localStorage.getItem('feature_flags')) return undefined;
  try {
    const flags = JSON.parse(window.localStorage.getItem('feature_flags') || '');
    return flags?.[feature];
  } catch {
    window.localStorage.removeItem('feature_flags');
    return undefined;
  }
}

export function setLocalFlag(feature: Feature, on: boolean) {
  const treatment = on ? 'on' : 'off';
  if (typeof window === 'undefined') return;
  if (!window.localStorage.getItem('feature_flags')) {
    window.localStorage.setItem('feature_flags', JSON.stringify({ [feature]: treatment }));
    return;
  }
  try {
    const flags = JSON.parse(window.localStorage.getItem('feature_flags') || '');
    flags[feature] = treatment;
    window.localStorage.setItem('feature_flags', JSON.stringify(flags));
  } catch {
    window.localStorage.setItem('feature_flags', JSON.stringify({ [feature]: treatment }));
  }
}

export function clearLocalFlag(feature: Feature) {
  if (typeof window === 'undefined') return;
  if (!window.localStorage.getItem('feature_flags')) return;
  try {
    const flags = JSON.parse(window.localStorage.getItem('feature_flags') || '');
    delete flags[feature];
    window.localStorage.setItem('feature_flags', JSON.stringify(flags));
  } catch {
    window.localStorage.removeItem('feature_flags');
  }
}
